import block from 'propmods';
import React from 'react';
import { Modal, Link, Button, Spin } from 'lego-on-react';
import * as keyset from 'i18n/Common';
import i18n from '@yandex-int/i18n';
import { CrossIcon } from '../../icons/cross';

import './Confirm.scss';

const t = i18n(keyset);

export interface Props {
    visible: boolean;
    progress: boolean;
    title?: string;
    description: React.ReactNode;
    onConfirm: () => void;
    onReject: () => void;
    width?: number;
    confirmText?: string;
    rejectText?: string;
}

const b = block('Confirm');

export default function Confirm(props: Props) {
    return (
        <Modal autoclosable visible={props.visible} onOutsideClick={props.onReject} directions={['bottom-left']}>
            <div {...b()} style={{ maxWidth: props.width }}>
                <div {...b('content')}>
                    {props.title && <h1>{props.title}</h1>}

                    {props.description}
                </div>
                <Link pseudo theme="normal" onClick={props.onReject}>
                    <CrossIcon color="#979797" />
                </Link>
                <Button theme="action" size="m" onClick={props.onConfirm} disabled={props.progress}>
                    {props.confirmText ?? t('yes')}
                </Button>
                <Button theme="normal" size="m" onClick={props.onReject} disabled={props.progress}>
                    {props.rejectText ?? t('no')}
                </Button>
                {props.progress && <Spin size="xxs" progress />}
            </div>
        </Modal>
    );
}
